// Shared formatting utilities

// Create formatters once for performance
const currencyFormatterNoDecimals = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

const currencyFormatterWithDecimals = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
})

/**
 * Format a number as USD currency
 * @param amount - The amount to format
 * @param decimals - Number of decimal places (default: 0)
 * @returns Formatted currency string
 */
export function formatCurrency(amount: number, decimals = 0): string {
  const formatter = decimals > 0 ? currencyFormatterWithDecimals : currencyFormatterNoDecimals
  return formatter.format(amount)
}

/**
 * Format an ISO date string as a readable date
 * @param dateString - ISO date string
 * @returns Formatted date string (e.g., "Feb 5, 2026")
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString)

  // Validate date
  if (isNaN(date.getTime())) {
    return 'Invalid Date'
  }

  return dateFormatter.format(date)
}

// Constants for date calculations
export const MS_PER_DAY = 86400000
export const CONFIDENCE_THRESHOLD = 0.8
